export default "__VITE_ASSET__B1u6zma9__"